import React, { useState } from "react";
import { Row, Col, Card, Nav, Tab } from "react-bootstrap";
import TicketListing from "./TicketListing";
import AnalyticsDashboard from "./AnalyticsDashboard";

const AdminDashboard = ({
  tickets = [],
  isLoading = false,
  searchTerm,
  setSearchTerm,
  statusFilter,
  setStatusFilter,
  priorityFilter,
  setPriorityFilter,
  startDate,
  endDate,
  onDateChange,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  tablePagination = [],
  userInfoData,
  handleTabChange,
  ADMIN_TABS,
  activeTab,
  onTicketClick,
  onTicketAction,
  ticketStats,
  // New filter props
  issueTypeFilter,
  setIssueTypeFilter,
  raisedByFilter,
  setRaisedByFilter,
  supervisorFilter,
  setSupervisorFilter,
  gymFilter,
  setGymFilter,
  breachedFilter,
  setBreachedFilter,
  issueTypeOptions,
  raisedByOptions,
  supervisorOptions,
  onResetFilters,
  handleReload,
}) => {
  // Function to determine if status filter should be hidden
  const shouldHideStatusFilter = (tabKey) => {
    // Define tabs where status filter should be hidden (tabs with predefined status)
    const tabsWithPredefinedStatus = [
      "open", // opened status
      "in_progress", // work_started status
      "work_completed", // work_completed status
      "resolved", // resolved status
      "sla_breached", // sla_breached status
    ];

    return tabsWithPredefinedStatus.includes(tabKey);
  };

  return (
    <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
      <Nav variant="tabs" className="mb-3">
        {Object.values(ADMIN_TABS)
          .filter((tab) => !tab.showCondition || tab.showCondition(ticketStats))
          .map((tab) => (
            <Nav.Item key={tab.key}>
              <Nav.Link
                eventKey={tab.key}
                className={tab.key === "sla_breached" ? "sla-breached-tab" : ""}
              >
                {tab?.label}
                {tab?.count && ` (${tab?.count(ticketStats)})`}
              </Nav.Link>
            </Nav.Item>
          ))}
      </Nav>
      <Tab.Content>
        {/* Analytics Tab */}
        {activeTab === "analytics" && (
          <Tab.Pane eventKey="analytics">
            <AnalyticsDashboard
              userInfoData={userInfoData}
              // Pass all filter props from parent
              searchTerm={searchTerm}
              statusFilter={statusFilter}
              priorityFilter={priorityFilter}
              startDate={startDate}
              endDate={endDate}
              onDateChange={onDateChange}
              issueTypeFilter={issueTypeFilter}
              raisedByFilter={raisedByFilter}
              supervisorFilter={supervisorFilter}
              gymFilter={gymFilter}
              breachedFilter={breachedFilter}
              issueTypeOptions={issueTypeOptions}
              raisedByOptions={raisedByOptions}
              supervisorOptions={supervisorOptions}
            />
          </Tab.Pane>
        )}

        {/* Other Tabs */}
        {activeTab !== "analytics" && (
          <Tab.Pane eventKey={activeTab}>
            <Card>
              <Card.Header
                className={
                  activeTab === "sla_breached" ? "sla-breached-header" : ""
                }
              >
                <h6 className="mb-0">
                  {activeTab === "sla_breached"
                    ? "⚠️ SLA Breached Tickets - Requires Immediate Attention"
                    : `${ADMIN_TABS[activeTab]?.label} Tickets`}
                </h6>
              </Card.Header>
              <Card.Body>
                <TicketListing
                  tickets={tickets}
                  onTicketClick={onTicketClick}
                  onTicketAction={onTicketAction}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  statusFilter={statusFilter}
                  setStatusFilter={setStatusFilter}
                  priorityFilter={priorityFilter}
                  setPriorityFilter={setPriorityFilter}
                  startDate={startDate}
                  endDate={endDate}
                  onDateChange={onDateChange}
                  isPage={isPage}
                  setIsPage={setIsPage}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  tablePagination={tablePagination}
                  userInfoData={userInfoData}
                  // New filter props
                  issueTypeFilter={issueTypeFilter}
                  setIssueTypeFilter={setIssueTypeFilter}
                  raisedByFilter={raisedByFilter}
                  setRaisedByFilter={setRaisedByFilter}
                  supervisorFilter={supervisorFilter}
                  setSupervisorFilter={setSupervisorFilter}
                  gymFilter={gymFilter}
                  setGymFilter={setGymFilter}
                  breachedFilter={breachedFilter}
                  setBreachedFilter={setBreachedFilter}
                  issueTypeOptions={issueTypeOptions}
                  raisedByOptions={raisedByOptions}
                  supervisorOptions={supervisorOptions}
                  onResetFilters={onResetFilters}
                  // Status filter visibility
                  hideStatusFilter={shouldHideStatusFilter(activeTab)}
                  handleReload={handleReload}
                />
              </Card.Body>
            </Card>
          </Tab.Pane>
        )}
      </Tab.Content>
    </Tab.Container>
  );
};

export default AdminDashboard;
